import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const ContactTabs = ({ 
  activeTab, 
  onTabChange, 
  messageCount = 0, 
  notesCount = 0 
}) => {
  const tabs = [
    {
      id: 'details',
      label: 'Details',
      icon: 'User',
      count: null
    },
    {
      id: 'history',
      label: 'History',
      icon: 'History',
      count: messageCount
    },
    {
      id: 'notes',
      label: 'Notes',
      icon: 'FileText',
      count: notesCount
    }
  ];

  return (
    <div className="bg-surface border-b border-border">
      {/* Mobile Tab Navigation */}
      <div className="lg:hidden">
        <div className="flex overflow-x-auto scrollbar-hide">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => onTabChange(tab?.id)}
              className={`flex-1 min-w-0 flex items-center justify-center space-x-2 py-4 px-4 border-b-2 transition-micro ${
                activeTab === tab?.id
                  ? 'border-primary text-primary bg-primary/5' :'border-transparent text-text-secondary hover:text-text-primary hover:bg-muted/50'
              }`}
            >
              <Icon name={tab?.icon} size={18} />
              <span className="font-medium truncate">{tab?.label}</span>
              {tab?.count !== null && tab?.count > 0 && (
                <span className="ml-1 px-2 py-0.5 bg-accent text-accent-foreground text-xs rounded-full min-w-[20px] text-center">
                  {tab?.count > 99 ? '99+' : tab?.count}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
      {/* Desktop Tab Navigation */}
      <div className="hidden lg:block px-6">
        <div className="flex space-x-8">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => onTabChange(tab?.id)}
              className={`flex items-center space-x-2 py-4 border-b-2 transition-micro ${
                activeTab === tab?.id
                  ? 'border-primary text-primary' :'border-transparent text-text-secondary hover:text-text-primary hover:border-border'
              }`}
            >
              <Icon name={tab?.icon} size={18} />
              <span className="font-medium">{tab?.label}</span>
              {tab?.count !== null && tab?.count > 0 && (
                <span className="ml-1 px-2 py-0.5 bg-accent text-accent-foreground text-xs rounded-full min-w-[20px] text-center">
                  {tab?.count > 99 ? '99+' : tab?.count}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactTabs;